import { getUuid } from '@/utils/commonUtil'
import { getDateYYYYMMDDHHMISS } from '@/utils/dateUtil'
import config from '@/conf/config'

export function getHeader() {
    // 从 localStorage 读取真实用户ID
    let userId = '-1'
    try {
        const userInfo = JSON.parse(localStorage.getItem('user'))
        if (userInfo && userInfo.userId) {
            userId = String(userInfo.userId)
        }
    } catch (e) {
        // localStorage 数据异常，忽略
    }

    const token = localStorage.getItem('token')
    let authorization = ""
    if (token) {
        authorization = `Bearer ${token}`
    }
    return {
        Authorization: authorization,
        'app-id': config.appId,
        'TRANSACTION-ID': getUuid(),
        'REQ-TIME': getDateYYYYMMDDHHMISS(),
        'SIGN': '',
        'user-id': userId
    }
}
